import React, { useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  Button,
  Grid,
  IconButton,
  Snackbar,
  Alert,
} from '@mui/material';
import { ContentCopy } from '@mui/icons-material';
import { motion } from 'framer-motion';

function ByteTag() {
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleCopyCode = (code) => {
    navigator.clipboard.writeText(code);
    setSnackbarOpen(true);
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <Typography variant="h2" gutterBottom color="text.primary" textAlign="center">
          Affiliate Programs & Discount Codes
        </Typography>
      </motion.div>

      {/* Advanced.gg Section */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        style={{ marginBottom: '2rem' }}
      >
        <Card sx={{ mb: 4, maxWidth: 600, mx: 'auto' }}>
          <CardContent sx={{ textAlign: 'center' }}>
            <Box
              component="img"
              src="/advggpinkcode.png"
              alt="Advanced.gg 10% Off"
              sx={{
                width: '100%',
                maxWidth: 300,
                height: 'auto',
                objectFit: 'contain',
                mb: 2,
              }}
            />
            <Typography variant="h5" gutterBottom>
              Advanced.gg Gaming Supplements
            </Typography>
            <Typography paragraph>
              Get 10% off Advanced.gg gaming supplements with code runerek10!
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap', mt: 2 }}>
              <Button
                variant="contained"
                color="primary"
                href="https://advanced.gg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Visit Advanced.gg
              </Button>
              <Button
                variant="outlined"
                startIcon={<ContentCopy />}
                onClick={() => handleCopyCode('runerek10')}
              >
                Copy Code: runerek10
              </Button>
            </Box>
          </CardContent>
        </Card>
      </motion.div>

      {/* ByteTag Section */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
      >
        <Typography variant="h3" gutterBottom color="text.primary" textAlign="center" sx={{ mb: 3 }}>
          ByteTag Ambassador
        </Typography>
      </motion.div>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.2 }}
          >
            <Card>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Box
                    component="img"
                    src="/bytetag.png"
                    alt="ByteTag Logo"
                    sx={{
                      width: 80,
                      height: 40,
                      objectFit: 'contain',
                      mr: 2,
                    }}
                  />
                  <Typography variant="h5">
                    What is ByteTag?
                  </Typography>
                </Box>
                <Typography paragraph>
                  ByteTag is a pet tag with a QR Code on the back. The QR Code stores your pet's
                  name, age, and behavioral notes in the ByteTag Website. You get GPS Alerts
                  whenever a tag is scanned (No Live GPS).
                </Typography>
                <Typography paragraph>
                  Worried about Privacy? You can hide any sensitive info while still sharing
                  return information.
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    href="http://bytetag.com/discount/byterunerek"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Visit ByteTag
                  </Button>
                  <Button
                    variant="outlined"
                    startIcon={<ContentCopy />}
                    onClick={() => handleCopyCode('byterunerek')}
                  >
                    Copy Code: byterunerek
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </motion.div>
        </Grid>

        <Grid item xs={12} md={6}>
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4 }}
          >
            <Card>
              <CardContent>
                <Typography variant="h5" gutterBottom>
                  My Personal Review
                </Typography>
                <Typography paragraph>
                  I purchased a Plastic ByteTag for Loki. He has since broken it and I haven't
                  purchased a new one. The reason I haven't got a new one is because the
                  information isn't needed.
                </Typography>
                <Typography paragraph>
                  If Loki was boarded or constantly traveling I would get it. It's an easy way
                  to share doctor's notes or medications for any dogs that need it. It's a
                  simple way of having all "documents" right in one QR Code.
                </Typography>
                <Typography variant="subtitle1" sx={{ fontStyle: 'italic', mt: 2 }}>
                  Best suited for:
                </Typography>
                <ul>
                  <li>Pets that travel frequently</li>
                  <li>Pets that need regular boarding</li>
                  <li>Pets with medical conditions or special needs</li>
                </ul>
              </CardContent>
            </Card>
          </motion.div>
        </Grid>
      </Grid>

      {/* Snackbar for copy confirmation */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
          Discount code copied to clipboard!
        </Alert>
      </Snackbar>
    </Container>
  );
}

export default ByteTag;